import MutateTicketType from "./MutateTicketType";

export default MutateTicketType